import { createContext, useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";

const TokenContext = createContext();

export const useToken = () => useContext(TokenContext);

export const TokenProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [usuarioData, setUsuarioData] = useState({});
  const [loading, setLoading] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const savedUser = localStorage.getItem("user");

    if (savedUser) {
      const user = JSON.parse(savedUser);
      setToken(user.token);
      setUsuarioData(user.user);
      axios
        .get(`${apiUrl}/users/${user.user.id}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        })
        .then((response) => {
          setPermissions(JSON.parse(response.data.user_profile.permissions));

          // Parseia o savedUser apenas uma vez para modificá-lo
          let parsedUser = JSON.parse(savedUser);

          if (response.data.view_group !== null) {
            parsedUser.user.view_group = response.data.view_group;
          } else {
            parsedUser.user.view_group = null;
          }

          // Atualiza o savedUser com a string JSON após as modificações
          localStorage.setItem("user", JSON.stringify(parsedUser));

          // Atualiza o estado do usuário
          setUsuarioData((prevUserData) => ({
            ...prevUserData,
            view_group: response.data.view_group || null,
          }));
        })
        .catch(() => {
          localStorage.removeItem("user");
          window.location.reload();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const updateToken = (newToken, newPermissions, newUser) => {
    const userData = {
      token: newToken,
      user: newUser,
    };
    delete userData.user.user_profile.permissions;

    localStorage.setItem("user", JSON.stringify(userData));

    setToken(newToken);
    setPermissions(newPermissions);
    setUsuarioData(newUser);
  };

  const hasPermission = (module, action) => {
    if (!module) {
      return true;
    }
    if (module !== "logs") {
      return permissions?.[module]?.[action]?.toString().charAt(0) === "1";
    } else {
      return permissions?.[module]?.toString().charAt(0) === "1";
    }
  };

  return (
    <TokenContext.Provider
      value={{
        token,
        permissions,
        updateToken,
        hasPermission,
        loading,
        usuarioData,
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};
TokenProvider.propTypes = {
  children: PropTypes.object.isRequired,
};
